import PropTypes from 'prop-types';
import React from 'react';

export const note = ({ event }) => <div>{event.data.note}</div>;

note.propTypes = {
  event: PropTypes.shape({
    bot: PropTypes.bool,
    created_at: PropTypes.string,
    data: PropTypes.shape({
      task: PropTypes.string,
      status: PropTypes.string,
    }).isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/note.jsx